const TableConfig = {
    name            : 'Task table',
    menuName        : 'Table',
    icon            : 'i5-table',
    image           : 'table',
    iconSvg         : 'isvg-view-table',
    url             : 'table',
    stringId        : 'tasks_table',
    description     : 'Advanced spreadsheet-like tasks view with project hierarchy support.',
    inheritance     : true,
    hasTemplates    : true,
    canBeInProject  : true,
}

export const PROJECT_TABLE_CONFIG = {
    ...TableConfig,
    // key2: "newValue2",  // Replacing the value for key2
}